// extracted by mini-css-extract-plugin
var _1 = "ra-quiz-start-banner";
var _2 = "ra-quiz-start-button";
var _3 = "ra-quiz-start-content";
export { _1 as "quizStartBannerCls", _2 as "quizStartButtonCls", _3 as "quizStartContentCls" }
